import { html, when, ViewTemplate, repeat, ref } from '@microsoft/fast-element';
import type { WatchlistProjectCard } from './watchlist-project-card';
import {
  getHtmlIconByName,
  getTechnologyIconName,
  normalChevron,
  starHighlightedIcon,
} from '../../../styles';
import { VPPA_WATCHLIST_COLUMNS } from './column-config';
import { getFillColorFromProjectStatus, getFormattedNumber } from '../../../utils/formatting';

export const WatchlistProjectCardTemplate: ViewTemplate<WatchlistProjectCard> = html`
  <div style="display: ${(x) => (x.renderWatchlistCard ? '' : 'none')}">
    <div
      class="${(x) =>
        x.gridVisibility && x.numberOfRows > 0
          ? 'watchlist-project-card watchlist-project-card-opened'
          : 'watchlist-project-card'}"
    >
      <div class="icon">
        <span>
          ${(x) =>
            getHtmlIconByName({
              name: getTechnologyIconName(x.project?.TECHNOLOGY),
              slot: 'start',
              width: '20px',
              height: '20px',
              fill: getFillColorFromProjectStatus(x.project?.PROJECT_OPERATIONAL_STATUS),
            })}
        </span>
      </div>
      <div style="display:flex;width: 100%;justify-content: space-between;">
        <div class="content">
          <div class="project-header-container">
            <p class="project-name" @click="${(x) => x.openProjectPage()}">
              ${(x) => x.project?.PROJECT_NAME}
            </p>
          </div>
          <p class="project-legal-name">
            ${(x) => x.project?.COMPANY_NAME.toUpperCase()} |
            ${(x) => getFormattedNumber(x.project?.MEGAWATT_AC)} MW | ${(x) => x.project?.ISO}
          </p>
        </div>
        <div class="button-container">
          <zero-button
            ${ref('favoriteBtn')}
            class="favorite-icon"
            type="button"
            @click="${(x) => x.switchCardsForDeletion()}"
          >
            ${starHighlightedIcon()}
          </zero-button>
          <zero-button
            class="${(x) =>
              x.gridVisibility && x.numberOfRows > 0
                ? 'chevron-control-button rotate-icon'
                : 'chevron-control-button'}"
            @click="${(x) => x.switchGridVisibility()}"
            ?disabled="${(x) => x.numberOfRows === 0}"
          >
            ${(x) => x.numberOfRows} ${normalChevron('end')}
          </zero-button>
        </div>
      </div>
    </div>

    <div
      class="vppa-grid"
      style="height: ${(x) => x.gridHeight}; display: ${(x) =>
        x.gridVisibility && x.numberOfRows > 0 ? '' : 'none'}"
    >
      <zero-grid-pro
        class="grid-styles watch-list-grid"
        only-template-col-defs
        sideBar=""
        :eventsAndCallbacks=${(x) => x.customEvents}
        ${ref('vppaGrid')}
      >
        ${repeat(
          (x) => VPPA_WATCHLIST_COLUMNS(x),
          html`
            <grid-pro-column :definition="${(x) => x}"></grid-pro-column>
          `,
        )}
      </zero-grid-pro>
    </div>
  </div>

  ${when(
    (x) => !x.renderWatchlistCard,
    html<WatchlistProjectCard>`
      <div>
        <div class="project-bg">
          <p class="remove-from-your-wat">Remove from your watchlist?</p>
          <p class="delete-title">${(x) => x.removeObject.NAME}</p>
          <div class="btn-holder">
            <zero-button class="cancel" type="button" @click=${(x) => x.cancelDeletion()}>
              Cancel
            </zero-button>
            <zero-button
              class="remove"
              type="button"
              @click="${(x) => x.deleteProjectFromWatchlist()}"
            >
              Remove
            </zero-button>
          </div>
        </div>
      </div>
    `,
  )}
`;
